import { CREATE_COSTING_HEADER_REQUEST, CREATE_COSTING_HEADER_SUCCESS, CREATE_COSTING_HEADER_FAILURE, CREATE_COSTING_HEADER_FORM, FETCH_COSTING_HEADER_REQUEST, FETCH_COSTING_HEADER_SUCCESS, FETCH_COSTING_HEADER_FAILURE, CREATE_COSTING_HEADER_DETAIL_FORM, CREATE_COSTING_HEADER_DETAIL_REQUEST, CREATE_COSTING_HEADER_DETAIL_SUCCESS, CREATE_COSTING_HEADER_DETAIL_FAILURE, FETCH_COSTING_SERIAL_NO_SUCCESS, FETCH_COSTING_SERIAL_NO_FAILURE, FETCH_COSTING_SERIAL_NO_REQUEST, FETCH_COSTING_HEADER_MAIN_GRID_REQUEST, FETCH_COSTING_HEADER_MAIN_GRID_FAILURE, FETCH_COSTING_HEADER_MAIN_GRID_SUCCESS, SET_EDIT_COSTING_DETAIL_DATA, COSTING_DETAIL_EDIT_DATA, UPDATE_COSTING_DETAIL_REQUEST, UPDATE_COSTING_DETAIL_SUCCESS, DELETE_COSTING_DETAIL_SUCCESS, DELETE_COSTING_DETAIL_REQUEST, UPDATE_COSTING_DETAIL_FAILURE, DELETE_COSTING_DETAIL_FAILURE, FETCH_COSTING_COMPARISION_DATA_REQUEST, FETCH_COSTING_COMPARISION_DATA_SUCCESS, FETCH_COSTING_COMPARISION_DATA_FAILURE, UPDATE_COSTING_HEADER_USERFORM_RESET, FETCH_COSTING_INVOICE_PRINT_DATA_REQUEST, FETCH_COSTING_INVOICE_PRINT_DATA_SUCCESS, FETCH_COSTING_INVOICE_PRINT_DATA_FAILURE, CREATE_COSTING_HEADER_USERFORM_RESET } from "./costingHeader.actionsType";



export const COSTING_HEADER = 'costingHeader';

let initialState = {
    loading: false,
    userform: {
        fldByTargetPrice: true,
        fldByMargin: false,
        fldIsActived: true,
    },
    CostingDetailform: {
    },
    CostingData: [],
    CostingDetailEditData: [],
    SerialNo: '',
    detailsId: '',
    //detailsIdDetail: '',
    CostMainGrid: [],
    UpdateDetailData: '',
    DeleteDetailData: '',
    detailupdate: '',
    detaildelete: '',
    CostComparision: [],
    CostingInvoiceDataV2: [],
};

export let costingHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_COSTING_HEADER_REQUEST:
        case FETCH_COSTING_HEADER_REQUEST:
        case CREATE_COSTING_HEADER_DETAIL_REQUEST:
        case FETCH_COSTING_SERIAL_NO_REQUEST:
        case FETCH_COSTING_HEADER_MAIN_GRID_REQUEST:
        case UPDATE_COSTING_DETAIL_REQUEST:
        case DELETE_COSTING_DETAIL_REQUEST:
        case FETCH_COSTING_COMPARISION_DATA_REQUEST:
        case FETCH_COSTING_INVOICE_PRINT_DATA_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_COSTING_HEADER_FORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_COSTING_HEADER_DETAIL_FORM:
            return {
                ...state,
                loading: false,
                CostingDetailform: {
                    ...state.CostingDetailform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_COSTING_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                detailsId: updatePayload
            };
        case CREATE_COSTING_HEADER_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                CostingDetailform: {},
                detailsIdDetail: updatePayload
            };
        case FETCH_COSTING_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                CostingData: updatePayload,
                CostingDetailEditData: updatePayload
            };
        case FETCH_COSTING_SERIAL_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                SerialNo: updatePayload
            };
        case FETCH_COSTING_HEADER_MAIN_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                CostMainGrid: updatePayload
            }
        case COSTING_DETAIL_EDIT_DATA:
            return {
                ...state,
                loading: false,
                CostingDetailEditData: payload
            };
        case UPDATE_COSTING_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                UpdateDetailData: updatePayload,
                //detailupdate: updatePayload

            };
        case DELETE_COSTING_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                DeleteDetailData: updatePayload,
                detaildelete: updatePayload,
            };
        case FETCH_COSTING_COMPARISION_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                CostComparision: updatePayload,
            };
        case FETCH_COSTING_INVOICE_PRINT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                CostingInvoiceDataV2: updatePayload,
            };
        case CREATE_COSTING_HEADER_FAILURE:
        case FETCH_COSTING_HEADER_FAILURE:
        case CREATE_COSTING_HEADER_DETAIL_FAILURE:
        case FETCH_COSTING_SERIAL_NO_FAILURE:
        case FETCH_COSTING_HEADER_MAIN_GRID_FAILURE:
        case UPDATE_COSTING_DETAIL_FAILURE:
        case DELETE_COSTING_DETAIL_FAILURE:
        case FETCH_COSTING_COMPARISION_DATA_FAILURE:
        case FETCH_COSTING_INVOICE_PRINT_DATA_FAILURE:
            return {
                ...state,
                loading: false
            };
        case SET_EDIT_COSTING_DETAIL_DATA:
            return {
                ...state,
                loading: false,
                CostingDetailEditData: payload
            };
        case UPDATE_COSTING_HEADER_USERFORM_RESET:
            return {
                ...state,
                CostingDetailform: {
                    fldWeightLossPercentage: 0,
                    fldProgramName: '',
                    fldSlNo: '',
                  //fldCategory: 'KG - Part'
                },
               // UpdateDetailData: ''
            }
        case CREATE_COSTING_HEADER_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldSize: '',
                    fldByTargetPrice: true,
                  fldByMargin: false,
                  fldIsActived: true,
                },
                
            }
        default:
            return state;
    }
};